import { useAppSelector } from "redux-share";
import { conditions } from "../../../../../helpers";
import { ConditionName } from "../../../../../interfaces";
import { handleBookmark } from "../../../../../redux/actions/user.actions";
import BookmarkIcon from "../../icon-components/bookmarkIcon";
import { shallowEqual } from "react-redux";

const Bookmark = () => {
    useAppSelector(({ user: { bookmarkId } }) => ({ bookmarkId }), shallowEqual);

    return (
        <>
            <div
                className="pl-flex pl-items-center pl-gap-[14px] pl-rounded-[20px] pl-text-secondary-700 dark:pl-text-secondary-50 pl-bg-gray-100 dark:pl-bg-dark-3 pl-px-4 pl-py-[7px] pl-cursor-pointer"
                onClick={handleBookmark}
            >
                <BookmarkIcon className="pl-w-4 pl-h-4 pl-fill-gray-800 dark:pl-fill-dark-6" isBookmark={conditions(ConditionName.isBookmark)} />
                <p>ذخیره</p>
            </div>
        </>
    );
};

export default Bookmark;
